import { isValidElement, type ReactNode } from "react"

export function hasVisibleText(node: ReactNode): boolean {
    if (node == null || typeof node === "boolean") return false

    if (typeof node === "string" || typeof node === "number") {
        return String(node).trim().length > 0
    }

    if (Array.isArray(node)) return node.some(hasVisibleText)

    if (isValidElement<{ children?: ReactNode }>(node)) {
        return hasVisibleText(node.props.children)
    }

    return false
}
